import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

export const TvlApyBlock = styled.div`
  width: 100%;
  height: 100%;
  margin-right: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  gap: 36px;

  @media (max-width: ${breakpoints.mobileLG}px) {
    gap: 12px;
    padding: 18px 24px 12px;
  }
`;
